export const addPathNameSlash = <T extends string>(pathname: T): WithSlash<T> =>
  pathname[pathname.length - 1] === '/' ? (pathname as WithSlash<T>) : `${pathname}/`;
